module.exports = __webpack_public_path__ + "img/slovakia-logo-icon.4b2661cf.png";